import React from "react";
import PropTypes from "prop-types";

const Button = ({
  title,
  icon,
  type,
  className,
  isBackgroundColor,
  ...props
}) => {
  return (
    <button
      className={
        isBackgroundColor ? "btn text-white btn-block" : className
      }
      type={type}
      style={{
        backgroundColor: isBackgroundColor ? "#E0A802" : null
      }}
      {...props}
    >
      <i className={icon}></i>
      {title}
    </button>
  );
};

Button.propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isBackgroundColor: PropTypes.bool.isRequired
};

export default Button;
